import { danger } from '../../../../../../../utils/brandColors';

export default () => ({
  editButton: { marginLeft: '4px' },
  nameTypography: { cursor: 'pointer' },
  error: { color: danger[500] },
  footer: {
    textAlign: 'right',
    paddingTop: '1rem',
  },
  right: { textAlign: 'right' },
  textField: {
    marginRight: '1rem',
    marginBottom: '1rem',
    width: 175,
  },
});
